import React from "react";
import { FormControl, Select, MenuItem } from "@mui/material";

const Dropdown = ({ value, options, onChange, label, disabled }) => {
  const getValue = () => {
    const opt = options.find((item) => item.id === value);
    if (!opt) return options[0].id;
    return value;
  };

  return (
    <FormControl
      sx={{ m: 1, minWidth: 160 }}
      variant="outlined"
      disabled={disabled}
    >
      <label>{label}</label>
      <Select
        value={getValue()}
        onChange={onChange}
        displayEmpty
        inputProps={{ "aria-label": "Without label" }}
      >
        {options.map((option) => (
          <MenuItem
            value={option.id}
          >{`${option.firstName} ${option.lastName}`}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default Dropdown;
